(() => {
  const script = document.getElementById('SbReviewVideoExperiment');
  const assignment = window.SBReviewVideoExperiment;
  const applyReview = (scope = document) => {
    if (!assignment || (!assignment.enabled && !assignment.preview) || assignment.arm !== 'estepario') return;
    scope.querySelectorAll('[data-sb-review-video-config]').forEach(config => {
      const root = config.closest('[data-hero-video-anchor]');
      const button = root?.querySelector('[data-hero-video-id="_51SXEe5oVo"]');
      if (!button) return;
      let media;
      try { media = JSON.parse(config.textContent); } catch (_) { return; }
      if (media.youtubeId !== 'ecTzGScFD8c' || !media.title || !media.playLabel) return;
      button.dataset.heroVideoId = media.youtubeId;
      button.dataset.heroVideoTitle = media.title;
      button.setAttribute('aria-label', media.playLabel);
      button.querySelector('.sb-hero-video__thumb-title').textContent = media.title;
      const originalImage = button.querySelector('img');
      if (originalImage) {
        // Replace the image so the old video's fallback error listener cannot restore Greg.
        const image = originalImage.cloneNode(false);
        ['data-hero-video-thumb-image', 'data-hero-video-image-init', 'data-fallback-primary', 'data-fallback-secondary'].forEach(name => image.removeAttribute(name));
        image.src = media.imageSrc || `https://i.ytimg.com/vi/${media.youtubeId}/hqdefault.jpg`;
        image.srcset = media.imageSrcset || '';
        originalImage.replaceWith(image);
      }
      if (button.getAttribute('aria-current') === 'true') {
        const frame = root.querySelector('[data-hero-video-featured-frame]');
        if (frame) {
          const src = `https://www.youtube.com/embed/${media.youtubeId}?rel=0`;
          frame.dataset.sbMediaSrc = src;
          if (frame.hasAttribute('src')) frame.src = src;
          frame.title = media.title;
        }
      }
    });
  };
  applyReview();
  document.addEventListener('DOMContentLoaded', () => applyReview());
  document.addEventListener('shopify:section:load', event => applyReview(event.target));
  const consent = window.SBAnalyticsConsent;
  if (!script || !consent || !assignment || (!assignment.enabled && !assignment.preview)) return;

  const trackingEnabled = Boolean(assignment) && script.dataset.track === 'true' && assignment.enabled === true && !assignment.preview && !assignment.forced && !Object.values(window.SBActiveExperiments || {}).some(test => test.forced) && !window.Shopify?.designMode;
  const sessionKey = assignment && `sb-review-video-visitor:${assignment.experiment}:${assignment.epochStart}`;
  const metricName = 'soundbrenner.com PDP review video visitor';
  let session = null;
  let eventInFlight = null;
  let attributeInFlight = null;
  const allowed = () => trackingEnabled && consent.analyticsAllowed() === true;
  const uniqueId = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const save = () => {
    try { localStorage.setItem(sessionKey, JSON.stringify(session)); } catch (_) {}
  };
  const restore = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(sessionKey));
      if (saved?.arm === assignment.arm && typeof saved.id === 'string' && /^[a-zA-Z0-9-]+$/.test(saved.id) && saved.product && Date.parse(saved.enrolledAt) >= Date.parse(assignment.epochStart) && Date.parse(saved.enrolledAt) <= Date.now()) session = saved;
    } catch (_) {}
  };
  const attributes = () => ({
    sb_review_video_experiment: allowed() && session?.tracked ? assignment.experiment : '',
    sb_review_video_variant: allowed() && session?.tracked ? assignment.arm : '',
    sb_review_video_analytics_eligible: allowed() && session?.tracked ? 'true' : 'false',
    sb_review_video_exposure: allowed() && session?.tracked ? session.id : '',
  });
  const syncCheckoutInputs = () => {
    document.querySelectorAll('[data-cart-checkout-button]').forEach((button) => {
      const form = button.closest('form');
      if (!form) return;
      Object.entries(attributes()).forEach(([name, value]) => {
        const inputName = `attributes[${name}]`;
        let input = form.querySelector(`input[name="${inputName}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = inputName;
          form.appendChild(input);
        }
        input.value = value;
      });
    });
  };
  const attributeCart = () => {
    syncCheckoutInputs();
    if (attributeInFlight || typeof window.SBCart?.updateAttributes !== 'function') return attributeInFlight;
    const cart = window.SBCart.getCart?.();
    if (!cart?.item_count) return;
    const values = attributes();
    const signature = JSON.stringify(values);
    if (Object.entries(values).every(([key, value]) => `${cart.attributes?.[key] || ''}` === value)) return;
    // Serialize attribution with other cart writes; send analytics separately.
    attributeInFlight = window.SBCart.updateAttributes(values, { source: 'review-video-experiment' })
      .catch(() => {})
      .finally(() => {
        attributeInFlight = null;
        if (JSON.stringify(attributes()) !== signature) return attributeCart();
      });
    return attributeInFlight;
  };
  const sendExposure = () => {
    if (!allowed() || !session || session.tracked || eventInFlight) return eventInFlight;
    const exposure = session;
    if (!window.SBABAnalytics) return;
    eventInFlight = (async () => {
      for (let attempt = 0; attempt < 3 && allowed(); attempt += 1) {
        try {
          const response = await window.SBABAnalytics.sendExposure(metricName, {
            experiment: assignment.experiment, variant: assignment.arm, exposure_id: exposure.id,
            entry_product: exposure.product, enrolled_at: exposure.enrolledAt,
            device_type: matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
          });
          if (response.ok) {
            exposure.tracked = true;
            save();
            attributeCart();
            return;
          }
          if (response.status < 500 && response.status !== 429) return;
        } catch (_) {}
        await new Promise((resolve) => setTimeout(resolve, 500 * (attempt + 1)));
      }
    })().finally(() => { eventInFlight = null; });
    return eventInFlight;
  };
  const enroll = () => {
    if (allowed() && !session) restore();
    if (allowed() && !session && assignment.eligible && document.querySelector('[data-sb-review-video-config]')) {
      session = { id: uniqueId(), arm: assignment.arm, product: assignment.product,
        enrolledAt: new Date().toISOString(), tracked: false };
      save();
    }
    const pending = attributeCart();
    const exposure = sendExposure();
    return exposure ? exposure.then(() => attributeCart()) : pending;
  };
  document.addEventListener('cart:updated', (event) => {
    if (event.detail?.source === 'review-video-experiment') syncCheckoutInputs();
    else enroll();
  });
  document.addEventListener('shopify:section:load', enroll);
  consent.whenReady(enroll);
  consent.onCheckout(enroll);
  document.addEventListener('sb:cart-system-ready', enroll);
  syncCheckoutInputs();
  if (trackingEnabled) enroll();
})();
